<template>
  <div class="sns">
    <a v-for="sns in list" :key="sns.id" :href="sns.url" target="_blank"><img :src="require(`@/assets/img/sns_${sns.id}.png`)" :alt="sns.label"></a>
  </div>
</template>

<script>
export default {
  name: 'Sns',
  props: [
    'list'
  ]
}
</script>
